import React from "react";

const PricingCards = () => {
  return (
    <section className="py-8 bg-gray-100">
      <div className="container px-2 pt-4 pb-12 mx-auto text-gray-800">
        <h1 className="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-800">
          Unser Angebot
        </h1>
        <div className="w-full mb-4">
          <div className="w-64 h-1 py-0 mx-auto my-0 rounded-t opacity-25 gradient" />
        </div>

        <div className="flex flex-col justify-center pt-12 my-12 sm:flex-row sm:my-4">
          <div className="z-10 flex flex-col w-5/6 mx-auto mt-4 bg-white rounded-lg shadow-lg lg:w-1/3 lg:mx-0 sm:-mt-6">
            <div className="flex-1 overflow-hidden bg-white rounded-t rounded-b-none shadow">
              <div className="w-full p-8 text-3xl font-bold text-center">
                <img
                  className="relative inline-block"
                  src={require("../images/getsby_logo_grey.svg")}
                  alt="getsby"
                  style={{ width: "auto", height: "35px" }}
                />{" "}
                Flex
              </div>
              <div className="w-full h-1 py-0 my-0 rounded-t gradient" />
              <ul className="w-full text-base text-center">
                <li className="py-4 font-bold border-b">Tischservice ✓</li>
                <li className="py-4 font-bold border-b">
                  Take-Away & Self Service ✓
                </li>
                <li className="py-4 font-bold border-b">Lieferung ✓</li>
                <li className="py-4 font-bold border-b">
                  Vorbestellen & Reservieren ✓
                </li>
                <li className="py-4 text-gray-500 border-b">
                  Setup - Alle Funktionen inkl. Tischservice 169€
                </li>
                <li className="py-4 text-gray-500 border-b">
                  Setup - Take-Away, Lieferung & Drive-In 99€
                </li>
              </ul>
            </div>
            <div className="flex-none p-6 mt-auto overflow-hidden bg-white rounded-t-none rounded-b shadow">
              <div className="w-full pt-6 text-4xl font-bold text-center">
                0€ <span className="text-base">pro Monat</span>
              </div>
              <div className="w-full pt-3 font-bold text-center">9% flex</div>
              <div className="w-full pt-3 font-bold text-center">
                +0,25€ pro Transaktion
              </div>
              <div className="flex items-center justify-center">
                <a
                  className="px-8 py-4 mx-auto my-6 font-bold text-white rounded-full shadow-lg lg:mx-0 hover:underline gradient"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSc1Ex0h6Urdiar-NAKdI01ZYSuJ1o5hz8veZW2o7r-UYgtnhQ/viewform"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Weitere Infos anfordern
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingCards;
